import { useQuery, useInfiniteQuery } from "@tanstack/react-query"
import { getVideoLogs, getVideoLogById } from "../api/videoLogs"

export const useVideoLogs = ({ limit = 20, sortBy, filters }) =>
  useInfiniteQuery({
    queryKey: ["videoLogs", "infinite", sortBy, filters],
    queryFn: ({ pageParam = 0 }) =>
      getVideoLogs({
        offset: pageParam,
        limit,
        sortBy,
        ...filters,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const loadedItems = allPages.reduce(
        (sum, page) => sum + page.data.data.length,
        0
      )
      return lastPage.data.data.length === limit ? loadedItems : undefined
    },
    initialPageParam: 0,
    retry: 0,
    staleTime: 0,
    refetchInterval: 1 * 60 * 1000,
    select: (data) => {
      const lastPage = data?.pages?.[data?.pages?.length - 1]?.data
      const flattenedData = data?.pages?.flatMap((page) => page.data.data) || []
      return {
        data: flattenedData,
        total: lastPage?.total || 0,
        page: lastPage?.page || 1,
        limit: lastPage?.limit || limit,
        totalPages: lastPage?.totalPages || 1,
      }
    },
  })

export const useVideoLogById = (reportId) =>
  useQuery({
    queryKey: ["videoLogById", reportId],
    queryFn: () => getVideoLogById(reportId),
    retry: 0,
    enabled: !!reportId,
    select: (data) => data?.data || null,
  })
